"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiImageUploadPanel = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var operators_1 = require("rxjs/operators");
var index_1 = require("../index");
var imageSizeLimit = 10485760;
var MultiImageUploadPanel = exports.MultiImageUploadPanel = /** @class */ (function (_super) {
    __extends(MultiImageUploadPanel, _super);
    function MultiImageUploadPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.handleImageRemove = function (image) {
            _this.handleRequest(_this.falconConvenienceApiService.deleteImage(_this.props.reference, image.id));
        };
        _this.renderImages = function () {
            return _this.state.images.map(function (image, index) { return (_this.renderImage(image)); });
        };
        _this.renderImageUploader = function () {
            var uploaderDisabled = _this.state.images.length >= _this.props.numberOfImages;
            var plusIcon = uploaderDisabled ? "plus-gray.svg" : "plus-white.svg";
            var btnClass = "btn-add-file ".concat(uploaderDisabled ? "btn-disabled" : "");
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "image-uploader-btn" },
                    React.createElement("label", { className: btnClass, htmlFor: "item-image-upload-input" },
                        React.createElement("img", { alt: "Plus icon", src: "/".concat(index_1.resourcesHelper.THEME, "/img/").concat(plusIcon) }),
                        React.createElement("span", null, "Add file")),
                    React.createElement("input", { type: "file", id: "item-image-upload-input", accept: ".jpg, .jpeg, .png", className: "d-none", disabled: uploaderDisabled, onChange: _this.getFile }))));
        };
        _this.getFile = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var imageFile, imageSize, imageSizeTooLarge, filename_1, compressedFile, e_1, reader_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageFile = event.target.files[0];
                        imageSize = imageFile.size;
                        imageSizeTooLarge = imageSize > imageSizeLimit;
                        this.setState({ imageError: undefined });
                        if (!imageFile) return [3 /*break*/, 5];
                        if (imageSizeTooLarge) {
                            this.setState({
                                showOverlay: false,
                                imageError: "Please upload an image that’s under 10MB"
                            });
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        this.setState({ showOverlay: true });
                        filename_1 = imageFile.name;
                        compressedFile = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.compressImage(imageFile)];
                    case 2:
                        compressedFile = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({
                            showOverlay: false,
                            imageError: "Oops, you’ve uploaded invalid image type. Try again using .jpg, .jpeg, .png"
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        if (compressedFile) {
                            reader_1 = new FileReader;
                            reader_1.readAsDataURL(compressedFile);
                            reader_1.onload = function () {
                                var base64 = reader_1.result;
                                var duplicate = _this.state.images.find(function (image) {
                                    return base64 == image.imageBase64;
                                });
                                _this.setState({ showOverlay: false });
                                if (duplicate) {
                                    return;
                                }
                                _this.handleImageUpload(base64, filename_1);
                            };
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            images: [],
            imageError: undefined,
            showOverlay: false,
            nonSavedImagesIds: [],
            uploadImageCalled: false
        };
        _this.fetchImages();
        return _this;
    }
    MultiImageUploadPanel.prototype.render = function () {
        if (this.props.removeNewAddedImages === true) {
            this.removeUnsavedImagesAndClose();
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "form-group image-uploader-container" },
                this.props.headerBlock && this.props.headerBlock(),
                this.props.footerBlock && this.props.footerBlock(),
                this.renderImageUploader(),
                this.renderImages(),
                this.state.showOverlay && this.props.overlay && this.props.overlay(),
                !!this.state.imageError && (React.createElement("div", { className: "invalid-feedback d-block p-2 text-center" },
                    React.createElement("b", null, this.state.imageError))))));
    };
    MultiImageUploadPanel.prototype.removeUnsavedImagesAndClose = function () {
        for (var _i = 0, _a = this.state.nonSavedImagesIds; _i < _a.length; _i++) {
            var id = _a[_i];
            this.handleRequest(this.falconConvenienceApiService.deleteImage(this.props.reference, id));
        }
        this.props.toggleParentModalClose && this.props.toggleParentModalClose();
    };
    MultiImageUploadPanel.prototype.fetchImages = function () {
        this.handleRequest(this.falconConvenienceApiService.getImages(this.props.reference));
    };
    MultiImageUploadPanel.prototype.handleImageUpload = function (base64Image, filename) {
        this.setState({
            uploadImageCalled: true
        });
        this.handleRequest(this.falconConvenienceApiService.postImage(this.props.reference, base64Image, filename));
    };
    MultiImageUploadPanel.prototype.handleRequest = function (observable) {
        var _this = this;
        if (this.state.showOverlay) {
            return;
        }
        this.setState({ showOverlay: true });
        observable
            .pipe((0, operators_1.finalize)(function () {
            _this.setState({ showOverlay: false });
        }))
            .subscribe(function (images) {
            if (_this.state.uploadImageCalled === true) {
                if (_this.state.images.length < images.length) {
                    _this.state.nonSavedImagesIds.push(images[images.length - 1].id);
                }
                _this.setState({
                    uploadImageCalled: false
                });
            }
            _this.setState({ images: images, showOverlay: false });
            _this.onChange(images);
        });
    };
    MultiImageUploadPanel.prototype.renderImage = function (image) {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "image-uploader-item" },
                React.createElement("p", null, (image === null || image === void 0 ? void 0 : image.filename) ? image.filename : "Untitled image"),
                React.createElement("div", { className: "image-uploader-item-close", onClick: function () { return _this.handleImageRemove(image); } },
                    React.createElement("b", { className: "text-decoration-underline" }, "Delete"),
                    React.createElement("img", { src: "/".concat(index_1.resourcesHelper.THEME, "/img/").concat("delete-icon.svg"), alt: "Delete image icon" }))));
    };
    MultiImageUploadPanel.prototype.onChange = function (images) {
        var uploadInput = document.getElementById("item-image-upload-input");
        if (uploadInput !== null) {
            // @ts-ignore
            document.getElementById("item-image-upload-input").value = "";
        }
        if (this.props.onChange) {
            this.props.onChange(images);
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], MultiImageUploadPanel.prototype, "falconConvenienceApiService", void 0);
    return MultiImageUploadPanel;
}(React.Component));
//# sourceMappingURL=MultiImageUploadPanel.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/imageUpload/MultiImageUploadPanel.js
// module id = 2523
// module chunks = 0